import React from "react";
import styled, { css } from "styled-components";
import ToolTip from "../Modal/ToolTip";

interface SDisabled {
  disabled?: boolean;
}

interface SCheck extends SDisabled {
  check?: boolean;
}

interface RadioBtnProps extends SCheck {
  label?: string;
  clickEvent: () => void;
  noTooltip?: boolean;
  disabled?: boolean;
  sHeight?: number;
}

export default function RadioBtn({
  label,
  check,
  clickEvent,
  noTooltip,
  disabled,
  sHeight,
}: RadioBtnProps) {
  const tooptipMsgString = () => {
    switch (label) {
      case "무책":
        return "파티 요금, 보증금 전액 환불";

      case "무책 일할":
        return "오늘까지의 파티 요금 제외하고 일할 계산하여 환불 (보증금 포함)";

      case "유책":
        return "파티 요금만 일할 환불 (보증금 포함 X)";

      case "보상":
        return "파티 요금, 보증금 전액 환불, 파티 해산 보상금 적립";

      case "먹튀":
        return "파티장이 위약금 지불 불가 상황인 경우, 링키드가 파티장의 위약금 대납하고 파티 해산";

      case "즉시 결제":
        return "고객이 등록한 결제 수단으로 위 금액을 즉시 결제 진행 합니다.";

      case "링키드 머니 지급":
        return "고객이 등록한 결제 수단으로 위 금액만큼 링키드 머니를 충전하고 결제를 진행합니다.";

      case "카드 결제":
        return "고객이 등록한 결제 수단으로 위 금액을 즉시 결제 진행 합니다.";

      case "유튜브해산":
        return "유튜브 일할 환불 해산";

      default:
        break;
    }
  };

  return (
    <>
      <RadioBtnContainer sHeight={sHeight}>
        <RadioCircle
          check={check}
          disabled={disabled}
          onClick={() => {
            if (!disabled) {
              clickEvent();
            }
          }}
        >
          {check && <CheckedCircle />}
        </RadioCircle>
        <Label
          disabled={disabled}
          onClick={() => {
            if (!disabled) {
              clickEvent();
            }
          }}
        >
          {label}
        </Label>

        {!noTooltip && (
          <ToolTip
            iconSize={18}
            msg={tooptipMsgString() ?? ""}
            direction="bottom"
            sMargin={label === "보상" || label === "먹튀" ? "0 120px 0 0" : "0"}
          />
        )}
      </RadioBtnContainer>
    </>
  );
}

const RadioBtnContainer = styled.div<{ sHeight?: number }>`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: ${({ sHeight }) => (sHeight ? `${sHeight}px` : "auto")};
`;

const RadioCircle = styled.div<SCheck>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid
    ${({ theme, check, disabled }) =>
      disabled && check
        ? theme.buttonColor.lineHover
        : check
          ? theme.buttonColor.blueNormal
          : theme.buttonColor.lineNormal};
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, check, disabled }) =>
    disabled && check
      ? theme.buttonColor.lineHover
      : check
        ? theme.buttonColor.blueNormal
        : theme.color.white};
`;

const CheckedCircle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.white};
`;

const Label = styled.label<SDisabled>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #1e1e1e;
  margin-right: 2px;
`;
